<template>
  <div class="statistics">

    <div class="search">
      <div class="search_box">
        <div v-for="item in search" :class='["search_options_box"]'>
          <span style="width: 100px;">{{item.title}}</span>
          <el-select class="select" v-model="selectValue" placeholder="请选择项目">
            <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
          </el-select>
        </div>
        <div class="search_btn_box">
          <button :class='["search_btn","green","icon_btn","clearborder"]' @click="getOnStatic()"><span class="el-icon-search"></span>查找</button>
        </div>
      </div>
    </div>

    <div style="padding: 20px 20px 0;height: 100%;box-sizing: border-box">

      <div class="statistical_overview">
        <div v-for="(item,index) in statistical" class="statistical_box"
             :style="{'background':'url('+item.bg+') left center'}">
          <div :style="[{background:'url('+item.icon+') no-repeat center center'}]"></div>
          <div>
            <p :style="[{color:item.color}]">{{item.name}}</p>
            <span :style="[{color:item.color}]">{{model[index].name}}</span>
          </div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(50% - 12px)'},{height:'calc(50% - 95px)'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <h1>广告收入统计</h1>
          <div id="income"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(50% - 12px)'},{height:'calc(50% - 95px)'},{marginLeft:'20px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <h1>广告统计分析</h1>
          <div id="static"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(50% - 12px)'},{height:'calc(50% - 95px)'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <h1>广播类型</h1>
          <div id="type"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(50% - 12px)'},{height:'calc(50% - 95px)'},{marginLeft:'20px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <h1>
            播放列表
          </h1>
<!--          <div id="program">-->
<!--            <div v-show="pic" class="box">-->
<!--              <ul>-->
<!--                <li v-for="(item,index) in data" v-if="item.type==='IMG' " :key="index">-->
<!--                  <img :src="'http://cloud.e-zhanshi.cn/'+item.file_url" :alt="item.name">-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--            <div v-show="!pic" class="box">-->
<!--              <ul>-->
<!--                <li v-for="(item,index) in data" v-if="item.type==='VIDEO' " :key="index">-->
<!--                  <video width="118px" height="264px" controls>-->
<!--                    <source :src="'http://cloud.e-zhanshi.cn/'+item.file_url"  type="video/mp4">-->
<!--                    <source :src="'http://cloud.e-zhanshi.cn/'+item.file_url"  type="video/ogg">-->
<!--                  </video>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->

          <!--table-->
          <div class="table_content">
            <table>
              <thead>
              <tr>
                <th style="width: 100px !important;">序号</th>
                <th>文件名</th>
                <th>文件时长</th>
                <th>文件类型</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in resourcePageData">
                <td>{{index+1}}</td>
                <td style="width: 400px;">{{item.name}}</td>
                <td>{{item.durations}}</td>
                <td>{{item.type}}</td>
              </tr>
              </tbody>
            </table>
          </div>
<!--          <div class="table_paging" style="margin-right:1.6%">-->
<!--            <p>当前记录<span>{{(this.resourceCurrentPage-1)*2+1}}</span>到<span>{{(this.resourceCurrentPage-1)*2+this.resourcePageData.length}}</span>条，共<span>{{this.resourceTotalCount}}</span>条记录-->
<!--              <button @click="resourceFirstPage()"-->
<!--                      v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>-->
<!--              <button-->
<!--                @click="resourcePrevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>-->
<!--              第<span>{{resourceCurrentPage}}</span>/<span>{{Math.ceil(resourceTotalCount/pageSize)}}</span>页-->
<!--              <button-->
<!--                @click="resourceNextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>-->
<!--              <button @click="resourceLastPage()"-->
<!--                      v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>-->
<!--            </p>-->
<!--          </div>-->


        </div>
      </div>

    </div>


  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts');
  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  require('echarts/lib/chart/scatter');
  require('echarts/lib/chart/effectScatter');
  require('echarts/lib/chart/radar');
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');
  require('echarts/lib/component/geo');
    export default {
        name: "statistics",
      data() {
        return {
          resourceCurrentPage: 1, // 当前页数 ，默认为1
          resourceTotalCount: 0,  // 总记录条数
          pageSize: 2, // 每页显示数量
          resourcePageData: [],
          search: [
            {
              title: '选择项目',
              options: [],
            },
          ],
          selectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
          projectList:[],
          statistical: [
            {name: "设备在线数", icon: "/static/img/msg/mag1.svg", color: "#f5b03b", bg: "/static/img/msg/number_bg.png"},
            {name: "设备总数", icon: "/static/img/msg/mag2.svg", color: "#76bbff", bg: "/static/img/msg/number_bg2.png"},
            {name: "设备故障数", icon: "/static/img/msg/mag3.svg", color: "#ff505d", bg: "/static/img/msg/number_bg3.png"},
          ],
          model: [
            {name: "4"},
            {name: "3"},
            {name: "1"},
          ],
          article: [
            {
              emergency: '紧急',
              title: '关于石桥房VPN升级通知',
              time: '2019-07-23 13:23',
              content: '为提高设备运行稳定性，运营支撑部计划系统深信服厂商于2019年2月25日20:30对石桥左侧道附近的VPN进行检修升级，这里是文章简介示例...'
            },
            {
              title: '关于石桥房VPN升级通知',
              time: '2019-07-23 13:23',
              content: '为提高设备运行稳定性，运营支撑部计划系统深信服厂商于2019年2月25日20:30对石桥左侧道附近的VPN进行检修升级，这里是文章简介示例...'
            }
          ],
          pic: true,
          //缓存数组

          data:[],
          projectId: "f899dfb4a9094ac48fbb27b64021d5e1",

          income_date_day: [
            {name: "今日", value: 215},
            {name: "08-16", value: 315},
            {name: "08-15", value: 925},
            {name: "08-14", value: 1235},
            {name: "08-13", value: 211},
            {name: "08-12", value: 131},
            {name: "08-11", value: 236},
            {name: "08-10", value: 321},
            {name: "08-09", value: 325},
            {name: "08-08", value: 315},
            {name: "08-07", value: 395},
            {name: "08-06", value: 316},
            {name: "08-05", value: 312},
            {name: "08-04", value: 325},
            {name: "08-03", value: 321},
          ],

        }
      },
      mounted() {
        $(function () {
          $('.income_btn').click(function () {
            $(this).addClass('focus').siblings().removeClass('focus');
          });
        });
        //初始化表格
        this.init();
        this.getOnStatic();
        this.getProjectList();
        this.getResourceList();
      },
      methods:{
        InitLeftMenu: function () {
          this.$emit('getMessage', '5', '0');
        },

        getOnStatic:function(){
          fetch("/api/v1/statistics", {
            method: 'post',
            body: JSON.stringify({
              project_id:this.selectValue
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              this.model[1].name = data.data.sound.total_count;
              this.model[0].name = data.data.sound.online_count;
              this.model[2].name = data.data.sound.fault_count;
              this.selectValue="";
            })
        },


        //获取项目列表
        getProjectList:function(){
          fetch("/api/v1/project/list", {
            method: 'post',
            body: JSON.stringify({

            })
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "项目数据获取成功";
                this.projectList = data.data;
                let options = this.search[0].options;
                for (let i=0;i<this.projectList.length;i++){
                  let projectObj = {};
                  projectObj.label = this.projectList[i].name;
                  projectObj.value = this.projectList[i].id;
                  options.push(projectObj);
                };
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },


        getResourceList: function () {
          fetch("/api/v1/sounder/statistics/resource/list", {
            method: 'post',
            body: JSON.stringify({
              project: this.selectValue,
              page_start: 0,
              page_size: 10,
            })
          }).then(result => {
            return result.json();//解析流
          }).then(data => {
            if (data.code == "200") {
              //this.resourceTotalCount = data.total_count;
              this.resourcePageData = data.data;
            }
          }).catch((error) => {
            console.log(error);
          });
        },


        //上一页
        resourcePrevPage() {
          if (this.resourceCurrentPage == 1) {
            return false;
          } else {
            this.resourceCurrentPage--;
            this.getResourceList();
          }
        },
        // 下一页
        resourceNextPage() {
          if (this.resourceCurrentPage == Math.ceil(this.resourceTotalCount/this.pageSize)) {
            return false;
          } else {
            this.resourceCurrentPage++;
            this.getResourceList();
          }
        },
        resourceFirstPage(){
          this.resourceCurrentPage = 1;
          this.getResourceList();
        },
        resourceLastPage(){
          this.resourceCurrentPage = Math.ceil(this.resourceTotalCount/this.pageSize);
          this.getResourceList();
        },

        init: function () {
          // if(this.income!==""){
          //   // this.$axios.get("",{
          //   //
          //   // }).then((res)=>{
          //   //    this.income_data_quarter = res
          //   // })
          // }
          let times = [
            {
              value: [
                "2019-1-1",
                214
              ]
            },
            {
              value: [
                "2019-11-2",
                512
              ]
            },
            {
              value: [
                "2019-12-15",
                564
              ]
            },
            {
              value: [
                "2019-9-2",
                312
              ]
            },
            {
              value: [
                "2019-10-15",
                156
              ]
            },
            {
              value: [
                "2019-10-6",
                646
              ]
            },
            {
              value: [
                "2019-1-12",
                856
              ]
            },
            {
              value: [
                "2019-7-10",
                456
              ]
            },
            {
              value: [
                "2019-10-9",
                1256
              ]
            },
            {
              value: [
                "2019-11-15",
                1156
              ]
            },
            {
              value: [
                "2019-4-15",
                1256
              ]
            },
            {
              value: [
                "2019-6-15",
                956
              ]
            }];
          let times2 = [
            {
              value: [
                "2019-4-1",
                145
              ]
            },
            {
              value: [
                "2019-8-2",
                220
              ]
            },
            {
              value: [
                "2019-6-15",
                641
              ]
            },
            {
              value: [
                "2019-7-22",
                456
              ]
            },
            {
              value: [
                "2019-8-12",
                665
              ]
            },
            {
              value: [
                "2019-3-25",
                841
              ]
            },
            {
              value: [
                "2019-1-15",
                641
              ]
            },
            {
              value: [
                "2019-11-22",
                456
              ]
            },
            {
              value: [
                "2019-6-12",
                1356
              ]
            },
            {
              value: [
                "2019-4-22",
                1211
              ]
            },
            {
              value: [
                "2019-1-31",
                894
              ]
            },
            {
              value: [
                "2019-4-22",
                641
              ]
            },];
          let times3 = [
            {
              time: "一月",
              value: [
                "2019-1-1",
                2284
              ]
            },
            {
              time: "二月",
              value: [
                "2019-2-1",
                1945
              ]
            },
            {
              time: "三月",
              value: [
                "2019-3-1",
                1825
              ]
            },
            {
              time: "四月",
              value: [
                "2019-4-1",
                1725
              ]
            },
            {
              time: "五月",
              value: [
                "2019-5-1",
                1652
              ]
            },
            {
              time: "六月",
              value: [
                "2019-6-1",
                1820
              ]
            },
            {
              time: "七月",
              value: [
                "2019-7-1",
                1920
              ]
            },
            {
              time: "八月",
              value: [
                "2019-8-1",
                2102
              ]
            },
            {
              time: "九月",
              value: [
                "2019-9-1",
                2300
              ]
            },
            {
              time: "十月",
              value: [
                "2019-10-1",
                2192
              ]
            },
            {
              time: "十一月",
              value: [
                "2019-11-1",
                2054
              ]
            },
            {
              time: "十二月",
              value: [
                "2019-12-1",
                2195
              ]
            },
            {
              time: "十二月",
              value: [
                "2020-1-1",
                2257
              ]
            }];

          let myChart1 = echarts.init(document.getElementById('income'));
          myChart1.setOption({
            grid: {
              left: '5%',
              top: "12%",
              right: '5%',
              bottom: '10%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
            },
            xAxis: {
              type: 'time',
              axisTick: {
                alignWithLabel: true
              },
              nameTextStyle: {
                color: "#ffffff"
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#244465",

                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#244465 '
                }
              },
              offset: 5,
              axisLabel: {
                textStyle: {
                  color: "#ffffff"
                }
              }
            },
            yAxis: {
              name: "收入(万元)",
              type: "value",
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 14,
                align: "left",
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#ffffff"
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#244465 '
                }
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#244465",
                }
              }
            },
            series: [{
              name: '收入总额',
              type: 'scatter',
              symbol: 'circle',
              symbolSize: 20,
              showSymbol: false,
              hoverAnimation: false,
              itemStyle: {
                normal: {
                  shadowBlur: 10,
                  shadowColor: 'rgba(120, 36, 50, 0.5)',
                  shadowOffsetY: 5,
                  color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                    offset: 0,
                    color: 'rgb(93, 249, 219)'
                  }, {
                    offset: 1,
                    color: 'rgb(77, 190, 165)'
                  }])
                }
              },
              data: times
            }, {
              name: '收入总额',
              type: 'scatter',
              symbol: 'circle',
              symbolSize: 20,
              showSymbol: false,
              hoverAnimation: false,
              itemStyle: {
                normal: {
                  shadowBlur: 10,
                  shadowColor: 'rgba(120, 36, 50, 0.5)',
                  shadowOffsetY: 5,
                  color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                    offset: 0,
                    color: 'rgb(61, 125, 234)'
                  }, {
                    offset: 1,
                    color: 'rgb(114, 162, 245)'
                  }])
                }
              },
              data: times2
            }, {
              name: '收入总额',
              type: 'line',
              smooth: true, //是否平滑曲线显示
              symbol: 'circle',  // 默认是空心圆（中间是白色的），改成实心圆
              symbolSize: 10,
              showSymbol: false,
              lineStyle: {
                normal: {
                  width: 5,
                  color: {
                    type: 'linear',
                    colorStops: [{
                      offset: 0,
                      color: '#4681e4' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#00fcc5' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  },
                }
              },
              itemStyle: {
                normal: {
                  color: '#fff',
                  symbolSize: 10,
                  borderWidth: 5,
                  /*shadowColor: 'rgba(72,216,191, 0.3)',
                  shadowBlur: 100,*/
                  borderColor: "#ffffff"
                }
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(14,230,205,0.4)'
                  },
                    {
                      offset: 1,
                      color: 'rgba(14,230,205,0)'
                    }
                  ], false),
                }
              },
              tooltip: {
                trigger: 'axis',
              },
              data: times3
            }]
          });

          var imgDatUrl = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAADECAYAAAD3RIMaAAADg0lEQVR4nO3dP28cRQCG8Wf29nKORRQXoUqQI6TYyCcRQAHJ6fgECAk3INFQBuUDIAoaKmihpKUwRYQoKNMlBZKrWKIACZNgExMSI58v9u3MUNw6cWzj9/7YCsX7SKNbnXdnf/LO7pUbQvUTJCADCULqf5KAuOfz8DFHZKEeULFIZDFElqkg1PuFCFSBUG+H+HS788Hr7K1k+OaAhXq09/2tDXwG3AEW67E8zOSDgo5CHFZ7VNxRoHYNeG9AxDC47+rtA4V9a6gdEgv0x9wAa+jZUbFnzcg1tBwiiyGGxc0PX7uzF9QmsUDuI4Zc1OOAnm6n8HOxE39lp/dy+eafEz/8cqa3/rAVX8pjXJexynmGlGcByrPbxcU3tlsXU4DV09Xd3yZ7VTfkaSCctCP0EsXjSNiJT871ZFEXGc5vlRfOb5V0G5mVid76WhknKvKZY0XEnBubMRRbkRAPXpND77LTMTDbOfXiDPCgjPxeVhsPiS9kaIykyORGJ4Xyn0jRTUf+5498DgXgXNXgXNU4ux0ya6HiLtX2Y3JrEEfYyZQPEuVGCqEabIUO/KRu5cB0bjJNs/UoJO6FivtUKUHxzI6JXP6dQnk/0ugMf5uM8tPBFAVTjVPMNprFWhX5Y6eisxFpribK9RhCHGXWfoXe5b8rCVwoS96anGByqUdzLTIOZmzQSWSQyiCVQSqDVAapDFIZpDJIZZDKIJVBKoNUBqkMUhmkMkhlkMoglUEqg1QGqQxSGaQySGWQyiCVQSqDVAapDFIZpDJIZZDKIJVBKoNUBqkMUhmkMkhlkMoglUEqg1QGqQxSGaQySGWQyiCVQSqDVAapDFIZpDJIZZDKIJVBKoNUBqkMUhmkMkhlkMoglUEqg1QGqQxSGaQySGWQyiCVQSqDVAapDFIZpDJIZZDKIJVBKoNUBqn+l6CrwO3nDaFvmC+AW/RR7wMrzwGyUp/76sb1+du77+vIwLfADeBj4BNg6oQhj4DPga82rs93d7/cv4a6wBfAJeBr+m8COu6qeu5LwJd7MYeBdvsLuAZcBr4/RsyNes5r9TkOpO6yZeAd4G1gaQzIUj3Hu4gXYg16298ErgAfAfeGgKzUx1yp55AN8xxKwDf0r/2nwOYR+27W+7xSH5MGPckoD8Yu/btj5pCTVfV3M/U+3QNHnwBot1X6l+NV4Md6XK6/Wx110n8BkRQ3ib0+PwAAAAAASUVORK5CYII=';
          var dimensions = ['5s', '10s', '15s', '30s', '45s', '60s'];
          var static_data = [42, 36, 13, 56, 9, 28];

          let myChart2 = echarts.init(document.getElementById('static'));
          myChart2.setOption({
            tooltip: {
              trigger: 'axis',
            },
            grid: {
              left: '5%',
              top: "12%",
              right: '5%',
              bottom: '10%',
              containLabel: true
            },
            xAxis: {
              data: dimensions,
              axisTick: {
                alignWithLabel: true
              },
              nameTextStyle: {
                color: "#ffffff"
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#244465",

                }
              },
              offset: 5,
              axisLabel: {
                textStyle: {
                  color: "#ffffff"
                }
              }
            },
            yAxis: {
              name: "收入(万元)",
              type: "value",
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 14,
                align: "left",
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#ffffff"
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#244465 '
                }
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#244465",
                }
              }
            },
            series: [{
              name: '收入',
              type: 'pictorialBar',
              symbol: imgDatUrl,
              color: "#45ded6",
              barGap: 0,
              symbolSize: [36, '100%'],
              data: static_data
            }]
          });

          let myChart3 = echarts.init(document.getElementById('type'));
          myChart3.setOption({
            tooltip: {},
            grid: {
              left: '5%',
              top: "12%",
              right: '5%',
              bottom: '10%',
              containLabel: true
            },
            radar: {
              radius: '75%',
              splitNumber: 8,
              axisLine: {
                lineStyle: {
                  color: '#fff',
                  opacity: .3
                }
              },
              splitLine: {
                lineStyle: {
                  color: '#fff',
                  opacity: .3
                }
              },
              splitArea: {
                areaStyle: {
                  color: '#114d8a',
                  opacity: 1,
                  shadowBlur: 45,
                  shadowColor: 'rgba(0,0,0,.5)',
                  shadowOffsetX: 0,
                  shadowOffsetY: 15,
                }
              },
              indicator: [{
                name: '公益宣传片',
                max: 6000
              }, {
                name: '政府发布',
                max: 16000
              }, {
                name: '紧急通知',
                max: 30000
              }, {
                name: '商业广告',
                max: 35000
              }, {
                name: '公告',
                max: 50000
              }, {
                name: '其他',
                max: 25000
              }]
            },
            series: [{
              name: '节目类型分布',
              type: 'radar',
              symbolSize: 0,
              areaStyle: {
                normal: {
                  shadowBlur: 13,
                  shadowColor: 'rgba(0,0,0,.2)',
                  shadowOffsetX: 0,
                  shadowOffsetY: 10,
                  opacity: 1
                }
              },
              data: [{
                value: [5000, 7000, 12000, 11000, 15000, 14000],
              }]
            }],
            color: ['#32a0d2'],
          });

          window.onresize = function () {
            myChart1.resize();
            myChart2.resize();
            myChart3.resize();
          };
        },
        img: function () {
          this.pic = true
        },
        video: function () {
          this.pic = false
        },
        getlist:function () {
          //获取媒体资源列表
          fetch("/api/v1/led/resource/list", {
            method: 'post',
            body: JSON.stringify({
              "project_id": this.selectValue,
              "page_start": 0,
              "page_size": 6,
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              this.data = data.data;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },
      created() {
        this.InitLeftMenu();
        this.getlist();
      }
    }
</script>

<style scoped>
  .statistics {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 76px;
  }

  .search_options_box {
    width: 275px;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #5a7595;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 36px;
    right: 20px;
    cursor: pointer;
  }

  .statistical_overview {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: space-between;
  }

  .statistical_box {
    width: calc(33% - 16px);
    height: 100%;
    background-color: #0b2f54;
    border-radius: 6px;
    border: 1px solid #5a7192;
    -webkit-box-shadow: 0 0 10px #16518d inset;
    box-shadow: 0 0 10px #16518d inset;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .statistical_box > div:nth-child(1) {
    width: 80px;
    height: 80px;
    margin: 0px 20px;
  }

  .statistical_box > div:nth-child(2) {
    font-size: 20px;
    font-weight: bold;
  }

  .nva_btn {
    padding: 20px;
  }

  .income_btn {
    background: transparent;
    font-size: 16px;
    border: transparent;
    outline: transparent;
    color: #95bee5;
    margin-right: 20px;
  }

  .focus {
    font-size: 18px;
    color: #00f0ff;
  }

  .view_more {
    width: 100%;
    height: 100%;
    color: #00f0ff;
    background: transparent;
    border: transparent;
    outline: transparent;
  }

  .win_title {
    height: 22px;
    background: url("/static/img/win_title.png") no-repeat;
    margin: 15px 20px 0px 20px;
  }

  .article {
    padding: 15px 20px 0px 20px;
  }

  .emergency {
    float: left;
    width: 44px;
    line-height: 21px;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    background: #ff0000;
    border-radius: 4px;
    margin-right: 10px;
  }

  .article_title {
    font-size: 20px;
    color: #00f0ff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
  }

  .article_time {
    font-size: 14px;
    color: #FFFFFF;
    opacity: 0.1;
    margin: 5px 0px;
  }

  .article_content {
    font-size: 16px;
    color: #95bee5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .information_content > h1 {
    font-size: 20px;
    color: #00f0ff;
    height: 20px;
    line-height: 20px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 10px;

  }

  .information_content > h1 > span {
    font-size: 16px;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
  }

  #income, #static, #type, #program {
    width: 100%;
    height: calc(100% - 50px);
  }
  .box{
    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: auto;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .box>ul{
    width: auto;
    white-space: nowrap;
    height: 100%;
  }
  .box>ul>li{
    width: calc(25% - 20px);
    height: 100%;
    float: left;
    margin-right: 20px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .box>ul>li>img{
    max-width: 100%;
    max-height: 100%;
  }
  .box>ul>li>video{
    max-width: 100%;
    max-height: 98%;
  }


  .table_content {
    width: 100%;
    height:280px;
    overflow:auto;
    /* height: calc(100% - 100px);*/
    padding: 0px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  .table_content > table tr td {
    /*background-color: #16518d;*/
  }

  .table_content > table input {
    width: 16px;
    height: 16px;
  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 41px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_content > table tr th select {
    background: transparent;
    color: #FFFFFF;
    border: none;
    outline: none;

  }

  .table_content > table tr th select option {
    color: #333333;

  }

  .table_paging {
    float: right;
    height: 40px;
    width: 96%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .search {
    width: 97%;
    height: 100px;
    padding: 20px 25px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/6_loudspeaker/statistics.vue